import { render } from "./FPluginDevMap.vue?vue&type=template&id=b4568212&scoped=true"
import script from "./FPluginDevMap.vue?vue&type=script&lang=js"
export * from "./FPluginDevMap.vue?vue&type=script&lang=js"

import "./FPluginDevMap.vue?vue&type=style&index=0&id=b4568212&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4568212"]])

export default __exports__